import { Col, Form, Row, Select } from 'antd';
import { observer } from 'mobx-react-lite';

import { EAccountStatus } from '../../core/account-status';

type Fields = 'accountStatus';
// for tab validation icon
export const StatusDataFieldsPath: Record<Fields, string[]> = {
  accountStatus: ['accountStatus'],
};

export const StatusDataFields = observer(() => {
  return (
    <Row gutter={16}>
      <Col span={12}>
        <Form.Item
          label="Статус аккаунта"
          name={StatusDataFieldsPath.accountStatus}
          rules={[
            { required: true, message: 'Поле обязательно для заполнения' },
          ]}
        >
          <Select>
            <Select.Option value={EAccountStatus.active}>
              Подтвержден
            </Select.Option>
            <Select.Option value={EAccountStatus.new}>
              Не подтвержден
            </Select.Option>
            <Select.Option value={EAccountStatus.blocked}>
              Заблокирован
            </Select.Option>
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
});
